import {
    IResult,
    IOverlayDelete,
    IOverlayClusterParameter,
    IPointSymbol
  } from '@/types/map';
import Feature, { FeatureLike } from 'ol/Feature';
import Point from 'ol/geom/Point';
import VectorLayer from 'ol/layer/Vector';
import { Cluster } from 'ol/source';
import VectorSource from 'ol/source/Vector';
import {Fill, Stroke, Icon, Style, Text} from 'ol/style';
import * as olColor from 'ol/color';

export class ClusterOpenlayers {
    private static instances: Map<string, any>;
    private view!: any;
    private map!: any;
    // private features: any;
    // private vertorSoource: any;
    // private clusterSource: any;
    private clusterLayers: any;
    private clusterLayerGroups: Map<string, any> = new Map();
    private constructor(map: any) {
        this.map = map;
    };
    public static getInstance(map: any){
        let id = map.getTarget();
        console.log(id);
        if (!ClusterOpenlayers.instances) {
            ClusterOpenlayers.instances = new Map();
        }
        let intance = ClusterOpenlayers.instances.get(id);
        if (!intance) {
          intance = new ClusterOpenlayers(map);
          ClusterOpenlayers.instances.set(id, intance);
        }
        return intance;
    }
    public static destroy() {
      (ClusterOpenlayers.instances as any) = null;
    }
    // 创建聚合图层
    public async addOverlaysCluster(params: IOverlayClusterParameter): Promise<IResult> {
        console.log("构造聚合图层：");
        let points = params.points || params.overlays || [];//所有需要聚合点数据
        let features: Feature<Point>[] = [];
        let vertorSoource;
        let clusterSource;
        let clusterLayer;
        let pointStyle: { (size: any): Style;[x: string]: any; };
        let countStyle = {};//聚合点样式
        points.forEach((point: any, index: number) => {//聚合点
            let feature = new Feature({
                geometry: new Point([point.geometry.x, point.geometry.y]),
                custom: {
                    id: point.id
                }
            });
            feature.setProperties({ fields: point.fields, markType: params.type, markId: point.id, symbol: point.symbol });
            features.push(feature);
        });
        console.log(features);
        vertorSoource = new VectorSource({//聚合点要素集
            features: features
        });
        clusterSource = new Cluster({//聚合类
            distance: params.distance,
            minDistance: params.minDistance,
            source: vertorSoource
        });
        // pointStyle = new Style({
        //     image: new Icon({
        //         src: (params.defaultSymbol as IPointSymbol).url,
        //         anchor: [0.5, 1],
        //         // size: (params.defaultSymbol as IPointSymbol).size,
        //         // width: (params.defaultSymbol as IPointSymbol).width,
        //         // height: (params.defaultSymbol as IPointSymbol).height,
        //     }),
        //     text: new Text({
        //         text: '\uf041',
        //         font: 'normal 18px FontAwesome',
        //         fill: new Fill({ color: 'red' }),
        //         stroke: new Stroke({ color: 'white', width: 2 }),
        //         offsetY: 15,
        //     })
        // });
        // let featuresLength = features.length;
        // let scale = ((params.defaultSymbol as IPointSymbol).scale != undefined ? (params.defaultSymbol as IPointSymbol).scale : 1);
        pointStyle = (size: any) =>{
            let text;
            let url;
            if (size == 1){
                text = "";
                url = (params.defaultSymbol as IPointSymbol).urlSingle;
            }else {
                text = size.toString();
                url = (params.defaultSymbol as IPointSymbol).url;
            };
            // let zoomSize;
            // if (size/featuresLength < 0.3){
            //     zoomSize = 0.3;
            // }else if (size/featuresLength >= 0.3 && size/featuresLength <= 0.7){
            //     zoomSize = 0.7;
            // }else {
            //     zoomSize = 1;
            // };
            return new Style({
                image: new Icon({
                    src: url,
                    anchor: [0.5, 1],
                    // scale: scale * zoomSize
                    // scale: scale * (size/featuresLength)
                    scale: (params.defaultSymbol as IPointSymbol).scale
                }),
                text: new Text({
                    text: text,
                    textAlign: "center",
                    justify: "center",
                    textBaseline: "middle",
                    padding: params.textStyle.padding || [1,2,1,2],
                    backgroundFill: new Fill({
                        color:  'rgb(' + params.textStyle.backgroundColor.join(',') + ")"
                    }),
                    backgroundStroke: new Stroke({
                        color: 'rgb(' + params.textStyle.borderColor.join(',') + ")",
                        width: params.textStyle.borderSize,
                        // lineCap: "round",//butt | round | square
                        // lineJoin: "round"//bevel | round | miter
                    }),
                    font: params.textStyle.fontSize + "px " +"Arial Unicode MS",
                    fill: new Fill({
                        color: 'rgb(' + params.textStyle.color.join(',') + ")"
                    }),
                    // stroke: new Stroke({
                    //     color: 'rgb(' + params.textStyle.borderColor.join(',') + ")",
                    //     // width: params.textStyle.borderSize,
                    //     width: 3,
                    //     // lineCap: "round",
                    //     // lineJoin: "round"
                    // }),
                    offsetX: (params.offsetX == undefined) ? 0 : params.offsetX,
                    offsetY: (params.offsetY == undefined) ? 10 : params.offsetY
                })
            });
        }
        function setFeatureStyle(feature: FeatureLike){
            const size = feature.get('features').length;//聚合点数量
            // feature.set('count', size);
            // feature.set('iamcluster', true);//用于判断是否是聚合点
            return pointStyle(size);
        };
        clusterLayer = new VectorLayer({//聚合图层
            source: clusterSource,
            // maxZoom: params.zoom,//minZoom
            // style: pointStyle,
            style: (feature) =>{
                return setFeatureStyle(feature)
            },
        });
        clusterLayer.set("label", params.type);//设置聚合图层唯一标识
        clusterLayer.set("cluster", true);//设置聚合图层类型
        this.map.addLayer(clusterLayer);
        this.clusterLayerGroups.set(params.type, clusterLayer);
        return {
            status: 0,
            message: 'ok'
        };
    };
    // 去除聚合图层
    public async deleteOverlaysCluster(params: IOverlayDelete) {
        let types = params.types;
        this.clearLayer(types);
    };
    private clearLayer(types: any){
        if (types && types.length > 0){
            types.forEach((type: any) => {
                let layer = this.clusterLayerGroups.get(type);
                if (layer){
                    this.map.removeLayer(layer);
                    this.clusterLayerGroups.delete(type);
                };
            });
        }else {
            this.clusterLayerGroups.forEach((layer) =>{
                this.map.removeLayer(layer);
            });
            this.clusterLayerGroups.clear();
        }
    };


}
